import { mxStrings } from 'utils/JobCollabStrings';

export const MALE_CHAR = 'm';
export const MALE = 'male';
export const FEMALE_CHAR = 'f';
export const FEMALE = 'female';
export const NEUTRAL = 'neutral';

// Given a first and last name, get the intials
export const extractInitials = (firstName?: string, lastName?: string): string => {
    if (!firstName && !lastName) {
        return mxStrings.noNameInitials;
    }

    const firstInitial = firstName ? firstName.charAt(0) : '';
    const lastInitial = lastName ? lastName.charAt(0) : '';

    return `${firstInitial}${lastInitial}`;
};

// Given some combination of first and last name, get the full name
export const buildFullName = (firstName?: string, lastName?: string): string => {
    if (!firstName && !lastName) {
        return '';
    } else if (!firstName && lastName) {
        return lastName;
    } else if (firstName && !lastName) {
        return firstName;
    } else {
        return `${firstName} ${lastName}`;
    }
};

export const getGenderClass = (gender?: string): string => {
    let genderClass = NEUTRAL;
    if (!gender || !gender.length) {
        return genderClass;
    }

    gender = gender.toLowerCase();

    if (gender === MALE || gender === MALE_CHAR) {
        genderClass = MALE;
    } else if (gender === FEMALE || gender === FEMALE_CHAR) {
        genderClass = FEMALE;
    }

    return genderClass;
};